import FullContentMessage from "./FullContentMessage";
export default FullContentMessage;
